import { JsonObject } from '../../app/json/jsonValue.js';

/**
 * Interface for dynamic view providers
 */
export abstract class IView {
    /**
     * Gets the full type name for DynamicView operation tracking
     */
    abstract get typeName(): string;

    /**
     * Gets dynamic view for template processing
     */
    abstract getView(
        appSite: string,
        appView: string,
        appFile: string,
        componentName: string,
        componentDepth: number,
        resolvedAppSite: string,
        resolvedComponentName: string,
        componentHtml: string,
        paramJson: JsonObject,
        componentJson: JsonObject,
        configJson: JsonObject | null
    ): string;

}
